import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search-icon",
  "use": "icon-search-icon-usage",
  "viewBox": "0 0 20.49 20.592",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20.49 20.592\" id=\"icon-search-icon\"><path d=\"m20.235 19.112-4.743-4.742a8.786 8.786 0 1 0-1.24 1.218l4.754 4.753a.869.869 0 0 0 1.229-1.229ZM1.735 8.767a7.024 7.024 0 1 1 7.024 7.024 7.032 7.032 0 0 1-7.021-7.028Z\" data-name=\"Path 198\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol